/**
 * Matches FixturesList "Upcoming" tab: OPEN + CLOSED/live, excludes FT/RESOLVED.
 */
export function isFixtureInUpcomingTab(fixture) {
  if (!fixture) return false;
  const status = fixture.status || 'NS';
  const marketState = fixture.marketState;

  const isFinished = ['FT', 'AET', 'PEN'].includes(status);
  const isResolvedMarket = marketState === 'RESOLVED';
  if (isFinished || isResolvedMarket) return false;

  const isUpcoming = ['NS', 'TBD'].includes(status);
  const isLive = ['1H', '2H', 'HT', 'ET', 'P', 'LIVE'].includes(status);
  const isClosedMarket = marketState === 'CLOSED';
  const isOpenMarket = marketState === 'OPEN' || (!marketState && !isClosedMarket);

  return isUpcoming || isLive || isClosedMarket || isOpenMarket;
}
